export default __webpack_public_path__ + "static/media/nft5.b331aa21.jpeg";